var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"superiority-box gx-5 p-4"},[_c('img',{attrs:{"src":_vm.contentData.contentImage,"alt":""}}),_c('div',{staticClass:"only-title"},[_vm._v(_vm._s(_vm.contentData.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }